<div class="mat-typography in-row" [ngStyle]="{'flex-direction': showInColumn ? 'column' : 'unset' }">
    <div class="in-row-value"
        title='Total duration of all “active” periods. Active period is the period between the "Process started" event and other events ("Process stopped", "Process deleted", "Process finished") or current time if a period has not ended.'>
        Work Time: {{workTimeStr}}</div>
    <div class="in-row-value"
        title='Total duration of all periods when the process was not active. (Life Time - Work Time).'>Waiting Time:
        {{waitingTimeStr}}</div>
    <div class="in-row-value"
        title='Total process existence duration from "Process created" and "Process deleted event" or the current time if the process is still running.'>
        Life Time: {{lifeTimeStr}}</div>
    <div class="in-row-value" title="The date the process was created.">Created: {{createdAtStr||'-'}}</div>
    <div class="in-row-value" title="The date the process was completed.">Finished: {{finishedAtStr||'-'}}</div>
    <div class="in-row-value" title="The date the process was deleted.">Deleted: {{deletedAtStr||'-'}}</div>
    <app-update-process-events-statistic-button class="inline-action-button"
        [ngStyle]="{'display': hideRefreshButton?'none':'unset' }" [stateEnv]="stateEnv"
        [processId]="statistic?.processId"
        [updateDataHandler]="updateStatistic.bind(this)"></app-update-process-events-statistic-button>
</div>